(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-text-video-split"] && !Shopify.designMode) return;
  try {
    
  const script = document.createElement('script');
  script.src = 'https://player.vimeo.com/api/player.js';
  script.defer = true;

  script.addEventListener('load', () => {
    document.querySelectorAll('[data-vimeo-player]').forEach(({ id }) => {
      new Vimeo.Player(id, {
        id,
        responsive: true,
      });
    });
  });

  document.head.append(script);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-full-bleed"] && !Shopify.designMode) return;
  try {
    
  const script = document.createElement('script');
  script.src = 'https://player.vimeo.com/api/player.js';
  script.defer = true;

  script.addEventListener('load', () => {
    document.querySelectorAll('[data-vimeo-player]').forEach(({ dataset, id }) => {
      const autoplay = dataset.vimeoAutoplay === 'true';
      const loop = dataset.vimeoLoop === 'true';

      new Vimeo.Player(id, {
        autoplay,
        id,
        loop,
        muted: autoplay,
        responsive: true,
      });
    });
  });

  document.head.append(script);

  } catch(e) { console.error(e); }
})();
})();
